import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {MSpinner} from 'components/Shared';
import WaiverDetails from 'components/Broker/WaiverDetails';

class Waiver extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { match: { params } } = this.props;
    this.props.getWaiverDetails(params.token);
  }

  render() {
    const {
      fetchingWaiverDetails, 
      waiverDetails
    } = this.props;
    if (fetchingWaiverDetails) {
      return <MSpinner/>;
    }    

    return (
      <div className="case-header md-grid">
        <WaiverDetails 
          isFetching={fetchingWaiverDetails} 
          waiver={waiverDetails} 
          onDecisionClick={this.props.saveWaiverDecision} />
      </div>
    );
  }
}

Waiver.propTypes = {
  fetchingWaiverDetails: PropTypes.bool.isRequired,
  waiverDetails: PropTypes.object.isRequired,
  getWaiverDetails: PropTypes.func.isRequired,
  saveWaiverDecision: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired
};
export default Waiver;

